export default __webpack_public_path__ + "static/media/success.4652f217.png";